import httpClient from 'agentHTTPClient';
import routes from 'agentRoutes';

export const SET_PASSENGER_TYPE_CODES = 'SET_PASSENGER_TYPE_CODES';
export const SET_PTC_LOADING = 'SET_PTC_LOADING';

export const setPassengerTypeCodes = passengerTypeCodes => ({
  type: SET_PASSENGER_TYPE_CODES,
  payload: passengerTypeCodes,
});

export const setPtcLoading = (isLoading) => ({
  type: SET_PTC_LOADING,
  payload: isLoading,
});


export function fetchPassengerTypeCodes() {
  return dispatch => {
    dispatch(setPtcLoading(true));

    httpClient.get(routes.api.passengerTypeCodes.list())
      .then(({ data }) => {
        dispatch(setPassengerTypeCodes(data));
        dispatch(setPtcLoading(false));
    })
  }
}
